/* GJ Quick Add - delegated handler, loaded once (deferred scripts may repeat; guard) */
(function () {
  if (window.__gjQuickAdd) return;
  window.__gjQuickAdd = true;

  /* Hovering (or focusing) "Become A Jerk" flips "Add to Cart" to black so the two buttons are
     never both orange. Uses mouseover/mouseout because they bubble, unlike mouseenter/leave. */
  function markSubHover(e, on) {
    var sub = e.target && e.target.closest ? e.target.closest('.gj-qa__btn--sub') : null;
    if (!sub) return;
    var group = sub.closest('.gj-qa');
    if (group) group.classList.toggle('gj-qa--sub-hover', on);
  }
  document.addEventListener('mouseover', function (e) { markSubHover(e, true); });
  document.addEventListener('mouseout', function (e) { markSubHover(e, false); });
  document.addEventListener('focusin', function (e) { markSubHover(e, true); });
  document.addEventListener('focusout', function (e) { markSubHover(e, false); });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gj-qa-add]') : null;
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    e.stopPropagation();

    var payload = { id: parseInt(btn.getAttribute('data-gj-qa-add'), 10), quantity: 1 };
    var plan = btn.getAttribute('data-gj-qa-plan');
    if (plan) payload.selling_plan = parseInt(plan, 10);

    var originalText = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓ Added';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
          btn.removeAttribute('aria-busy');
        }, 1600);
      })
      .catch(function () {
        // Fall back to the product page (e.g. sold out, variant needs choosing)
        var url = btn.getAttribute('data-gj-qa-url');
        if (url) window.location.href = url;
        else {
          btn.textContent = originalText;
          btn.removeAttribute('aria-busy');
        }
      });
  });
})();
